import * as Actions from '../actions/modernDashboard.actions';

const initialState = {
	metrics: null,
	loading: false,
	error: null,
	lastUpdated: null
};

const dashboardMetricsReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_DASHBOARD_METRICS_REQUEST:
		case Actions.GET_USER_DASHBOARD_METRICS_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case Actions.GET_DASHBOARD_METRICS_SUCCESS:
		case Actions.GET_USER_DASHBOARD_METRICS_SUCCESS:
			return {
				...state,
				metrics: action.payload,
				loading: false,
				error: null,
				lastUpdated: new Date().toISOString()
			};
		case Actions.GET_DASHBOARD_METRICS_FAILURE:
		case Actions.GET_USER_DASHBOARD_METRICS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		case Actions.UPDATE_DASHBOARD_METRICS_REALTIME:
			return {
				...state,
				metrics: state.metrics ? {
					...state.metrics,
					summary: action.payload.summary,
					timestamp: action.payload.timestamp
				} : null,
				lastUpdated: new Date().toISOString()
			};
		default:
			return state;
	}
};

export default dashboardMetricsReducer;
